(function () {
  "use strict";

  if (window.ARProCatalogue && typeof window.ARProCatalogue.initAll === "function") {
    window.ARProCatalogue.initAll(document);
    return;
  }

  function normalize(value) {
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLocaleLowerCase("fr")
      .trim();
  }

  function uniqueSorted(values) {
    return Array.from(new Set(values.filter(Boolean))).sort(function (left, right) {
      return left.localeCompare(right, "fr");
    });
  }

  function appendOptions(select, values) {
    uniqueSorted(values).forEach(function (value) {
      var option = document.createElement("option");
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });
  }

  function restoreCategoryFilter(select, requested) {
    var available = Array.prototype.map.call(select.options, function (option) { return option.value; });
    if (!requested || available.indexOf(requested) !== -1) {
      select.value = requested || "";
      return;
    }
    var aliases = {
      "Vodka BIO": "Vodka",
      "Gin BIO": "Gin",
      "Whisky BIO": "Whisky",
      "Rhum BIO": "Rhum",
      "Cognac BIO": "Cognac",
      "Pineau": "Pineau des Charentes",
      "Aperitif": "Apéritif",
      "Coffret whisky": "Coffret"
    };
    var canonical = Object.prototype.hasOwnProperty.call(aliases, requested) ? aliases[requested] : "";
    if (canonical && available.indexOf(canonical) !== -1) {
      select.value = canonical;
      return;
    }
    var unavailable = document.createElement("option");
    unavailable.value = requested;
    unavailable.textContent = requested;
    unavailable.disabled = true;
    select.appendChild(unavailable);
    select.value = requested;
  }

  function showRuntimeCountBlock(catalogue, actual, expected, detail) {
    catalogue.dataset.transactionReady = "false";

    var alert = catalogue.querySelector("[data-arpro-count-alert]");
    if (!alert) {
      alert = document.createElement("div");
      alert.className = "arpro-catalogue__blocker";
      alert.setAttribute("role", "alert");
      alert.setAttribute("data-arpro-count-alert", "");
      var toolbar = catalogue.querySelector("[data-arpro-catalogue-filters]");
      catalogue.insertBefore(alert, toolbar || catalogue.firstChild);
    }

    alert.replaceChildren();
    var title = document.createElement("strong");
    title.textContent = "Commande temporairement bloquée.";
    var message = document.createElement("span");
    if (detail) {
      message.textContent = detail;
    } else {
      var expectedLabel = Number.isInteger(expected) && expected > 0 ? String(expected) : "un total Shopify valide";
      message.textContent =
        "Le navigateur a rendu " + actual + " produit(s), alors que " + expectedLabel +
        " sont attendus. Aucun panier partiel ne peut être créé.";
    }
    alert.append(title, message);

    catalogue.querySelectorAll("[data-arpro-catalogue-product-form]").forEach(function (form) {
      form.dataset.transactionReady = "false";
      var button = form.querySelector("[data-arpro-add-button]");
      var status = form.querySelector("[data-arpro-form-status]");
      if (button) {
        button.disabled = true;
        button.setAttribute("aria-disabled", "true");
        button.textContent = "Commande bloquée";
      }
      if (status) status.textContent = "Contrôle d’exhaustivité du catalogue en échec.";
    });
  }

  function parseVariants(card) {
    var node = card.querySelector("[data-arpro-variant-data]");
    if (!node) return [];
    try {
      var variants = JSON.parse(node.textContent);
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      return [];
    }
  }

  var ALLOWED_SALE_UNITS = new Set([
    "unit",
    "unite",
    "bottle",
    "bouteille",
    "bib",
    "bidon",
    "coffret",
    "case",
    "caisse",
    "carton"
  ]);

  function variantReadiness(variant, mode) {
    var normalizedSaleUnit = normalize(variant && variant.saleUnit);
    var saleUnitAllowed = ALLOWED_SALE_UNITS.has(normalizedSaleUnit);
    var caseUnit = normalizedSaleUnit === "case"
      || normalizedSaleUnit === "caisse"
      || normalizedSaleUnit === "carton";
    var units = Number(variant && variant.unitsPerCase);
    var unitsResolved = Number.isFinite(units) && units > 0;
    var caseEligibilityResolved = Boolean(variant)
      && variant.caseEligibleResolved === true
      && typeof variant.caseEligible === "boolean";
    var packResolved = saleUnitAllowed && (!caseUnit || unitsResolved);

    if (mode === "grossistes") {
      packResolved = packResolved
        && caseEligibilityResolved
        && (variant.caseEligible !== true || unitsResolved);
    }

    var numericPrice = Number(variant && variant.price);
    var priceResolved = Number.isFinite(numericPrice)
      && numericPrice > 0
      && Boolean(variant && variant.priceFormatted);

    return {
      available: Boolean(variant && variant.available),
      caseEligibilityResolved: caseEligibilityResolved,
      caseUnit: caseUnit,
      numericPrice: numericPrice,
      packResolved: packResolved,
      priceResolved: priceResolved,
      ready: Boolean(variant && variant.available) && priceResolved && packResolved,
      saleUnitAllowed: saleUnitAllowed,
      units: units,
      unitsResolved: unitsResolved
    };
  }

  function expectedVariantGid(id) {
    var value = String(id || "");
    return value ? "gid://shopify/ProductVariant/" + value : "";
  }

  function hasValidProductMapping(card) {
    var form = card.querySelector("[data-arpro-catalogue-product-form]");
    var select = card.querySelector("[data-arpro-variant-select]");
    var variants = parseVariants(card);
    if (!form || !select || variants.length === 0) return false;

    var options = Array.prototype.slice.call(select.options);
    if (options.length !== variants.length) return false;

    var ids = variants.map(function (variant) { return String(variant.id || ""); });
    var optionIds = options.map(function (option) { return String(option.value || ""); });
    if (ids.some(function (id) { return id === ""; }) || new Set(ids).size !== ids.length) return false;
    if (optionIds.some(function (id) { return id === ""; }) || new Set(optionIds).size !== optionIds.length) return false;

    var idsSet = new Set(ids);
    var optionIdsSet = new Set(optionIds);
    var sameIdsBothWays = ids.every(function (id) { return optionIdsSet.has(id); })
      && optionIds.every(function (id) { return idsSet.has(id); });
    if (!sameIdsBothWays) return false;

    var variantsById = new Map(variants.map(function (variant) {
      return [String(variant.id), variant];
    }));
    return variants.every(function (variant) {
      return String(variant.variantGid || "") === expectedVariantGid(variant.id);
    }) && options.every(function (option) {
      var variant = variantsById.get(String(option.value));
      return Boolean(variant)
        && String(option.dataset.variantGid || "") === String(variant.variantGid || "")
        && String(option.dataset.variantGid || "") === expectedVariantGid(option.value);
    });
  }

  function updateProductImage(card, variant) {
    var media = card.querySelector("[data-arpro-product-media]");
    if (!media) return;

    var stage = media.querySelector("[data-arpro-media-stage]") || media;
    var image = stage.querySelector("[data-arpro-product-image], .arpro-catalogue-card__image");
    var placeholder = stage.querySelector("[data-arpro-image-placeholder]");

    if (variant.imageUrl) {
      if (!image) {
        image = document.createElement("img");
        image.setAttribute("data-arpro-product-image", "");
        image.className = "arpro-catalogue-card__image";
        image.loading = "lazy";
        image.sizes = "(min-width: 1088px) 25vw, (min-width: 608px) 50vw, 100vw";
        stage.appendChild(image);
      }
      image.src = variant.imageUrl;
      if (variant.imageSrcset) image.srcset = variant.imageSrcset;
      else image.removeAttribute("srcset");
      image.alt = variant.imageAlt || card.dataset.name || "Produit";
      if (placeholder) placeholder.remove();
      media.querySelectorAll("[data-arpro-media-thumbnail]").forEach(function (thumbnail) {
        var selected = thumbnail.dataset.imageUrl === variant.imageUrl;
        thumbnail.classList.toggle("is-active", selected);
        thumbnail.setAttribute("aria-pressed", selected ? "true" : "false");
      });
      return;
    }

    if (image) image.remove();
    if (!placeholder) {
      placeholder = document.createElement("span");
      placeholder.className = "arpro-catalogue-card__placeholder";
      placeholder.setAttribute("data-arpro-image-placeholder", "");
      placeholder.textContent = "Visuel non renseigné pour " + (card.dataset.name || "ce produit");
      stage.appendChild(placeholder);
    }
  }

  function initializeMediaGallery(card) {
    var media = card.querySelector("[data-arpro-product-media]");
    if (!media) return;

    media.querySelectorAll("[data-arpro-media-thumbnail]").forEach(function (thumbnail) {
      thumbnail.addEventListener("click", function () {
        var stage = media.querySelector("[data-arpro-media-stage]") || media;
        var image = stage.querySelector("[data-arpro-product-image], .arpro-catalogue-card__image");
        if (!image || !thumbnail.dataset.imageUrl) return;

        image.src = thumbnail.dataset.imageUrl;
        if (thumbnail.dataset.imageSrcset) image.srcset = thumbnail.dataset.imageSrcset;
        else image.removeAttribute("srcset");
        image.alt = thumbnail.dataset.imageAlt || card.dataset.name || "Produit";

        media.querySelectorAll("[data-arpro-media-thumbnail]").forEach(function (candidate) {
          var active = candidate === thumbnail;
          candidate.classList.toggle("is-active", active);
          candidate.setAttribute("aria-pressed", active ? "true" : "false");
        });
      });
    });
  }

  function quantityRules(variant) {
    var minimum = Number(variant.quantityMin);
    var increment = Number(variant.quantityIncrement);
    var maximum = variant.quantityMax === null || variant.quantityMax === ""
      ? null
      : Number(variant.quantityMax);

    if (!Number.isInteger(minimum) || minimum < 1) minimum = 1;
    if (!Number.isInteger(increment) || increment < 1) increment = 1;
    if (!Number.isFinite(maximum) || maximum < minimum) maximum = null;

    return { minimum: minimum, increment: increment, maximum: maximum };
  }

  function normalizeQuantity(input, variant) {
    var rules = quantityRules(variant);
    if (!input) return rules;

    input.min = String(rules.minimum);
    input.step = String(rules.increment);
    if (rules.maximum === null) input.removeAttribute("max");
    else input.max = String(rules.maximum);

    var value = Number(input.value);
    if (!Number.isFinite(value) || value < rules.minimum) value = rules.minimum;
    if ((value - rules.minimum) % rules.increment !== 0) {
      value = rules.minimum + Math.ceil((value - rules.minimum) / rules.increment) * rules.increment;
    }
    if (rules.maximum !== null && value > rules.maximum) {
      value = rules.minimum
        + Math.floor((rules.maximum - rules.minimum) / rules.increment) * rules.increment;
    }
    input.value = String(value);
    return rules;
  }

  function updateVariant(card, variant, options) {
    var price = card.querySelector("[data-arpro-variant-price]");
    var sku = card.querySelector("[data-arpro-variant-sku]");
    var quantity = card.querySelector("[data-arpro-quantity]");
    var quantityRule = card.querySelector("[data-arpro-quantity-rule]");
    var packInfo = card.querySelector("[data-arpro-pack-info]");
    var saleUnit = card.querySelector("[data-arpro-sale-unit]");
    var unitsPerCase = card.querySelector("[data-arpro-units-per-case]");
    var button = card.querySelector("[data-arpro-add-button]");
    var status = card.querySelector("[data-arpro-form-status]");

    var readiness = variantReadiness(variant, options.serverMode);
    var numericPrice = readiness.numericPrice;
    var priceResolved = readiness.priceResolved;
    var hasSaleUnit = readiness.saleUnitAllowed;
    var units = readiness.units;
    var hasUnits = readiness.unitsResolved;
    var packResolved = readiness.packResolved;
    var offerResolved = priceResolved;
    var rules = normalizeQuantity(quantity, variant);
    if (quantity) quantity.disabled = !(readiness.ready && options.transactionReady);

    if (price) price.textContent = offerResolved ? variant.priceFormatted : "Tarif à confirmer par l’ADV";
    if (sku) sku.textContent = variant.sku || "Non renseigné";
    card.dataset.price = offerResolved ? String(numericPrice) : "";

    if (quantityRule) {
      var rule = "Minimum " + rules.minimum + " · multiple de " + rules.increment;
      if (rules.maximum !== null) rule += " · maximum " + rules.maximum;
      quantityRule.textContent = rule;
    }

    if (packInfo) {
      packInfo.hidden = false;
      packInfo.classList.toggle("is-unresolved", !packResolved);
      if (saleUnit) saleUnit.textContent = variant.saleUnit || "À confirmer par l’ADV";
      if (unitsPerCase) {
        unitsPerCase.hidden = !hasUnits;
        unitsPerCase.textContent = hasUnits ? units + " unité(s) par caisse" : "";
      }
    }

    updateProductImage(card, variant);

    if (button) {
      var variantReady = readiness.ready;
      var canSubmit = variantReady && options.transactionReady;
      button.disabled = !canSubmit;
      button.dataset.variantAvailable = String(Boolean(variant.available));
      button.dataset.variantReady = String(variantReady);
      button.setAttribute("aria-disabled", canSubmit ? "false" : "true");
      if (canSubmit) button.textContent = "Ajouter au panier";
      else if (!variant.available) button.textContent = "Variante indisponible à la vente";
      else if (!priceResolved) button.textContent = "Tarif à confirmer par l’ADV";
      else if (!packResolved) button.textContent = "Conditionnement à confirmer";
      else button.textContent = "Commande bloquée";
    }
    var productForm = card.querySelector("[data-arpro-catalogue-product-form]");
    if (productForm) {
      productForm.dataset.variantAvailable = String(Boolean(variant.available));
      productForm.dataset.variantReady = String(readiness.ready);
      productForm.dataset.transactionReady = options.transactionReady ? "true" : "false";
    }
    if (status) {
      if (!variant.available) status.textContent = "Cette variante n’est pas disponible à la vente.";
      else if (!priceResolved) status.textContent = "Le tarif de cette variante doit être confirmé par l’ADV.";
      else if (!packResolved) status.textContent = "Le conditionnement ou l’éligibilité franco de cette variante n’est pas renseigné avec une valeur autorisée. Ajout bloqué.";
      else if (!options.transactionReady) status.textContent = "Cette offre n’est pas encore prête pour une transaction Shopify fiable.";
      else status.textContent = "";
    }

    card.dispatchEvent(new CustomEvent("arpro:variant:change", {
      bubbles: true,
      detail: { variantId: String(variant.id), price: offerResolved ? numericPrice : null }
    }));
  }

  function initializeProductForm(card, options) {
    var form = card.querySelector("[data-arpro-catalogue-product-form]");
    var select = card.querySelector("[data-arpro-variant-select]");
    if (!form || !select) return !options.transactionReady;

    var variants = parseVariants(card);
    var byId = new Map(variants.map(function (variant) {
      return [String(variant.id), variant];
    }));

    if (variants.length === 0) {
      form.dataset.transactionReady = "false";
      form.querySelectorAll("input, select, button").forEach(function (control) {
        control.disabled = true;
      });
      var missingStatus = form.querySelector("[data-arpro-form-status]");
      if (missingStatus) missingStatus.textContent = "Données de variantes indisponibles. Commande bloquée.";
      return false;
    }

    var fieldset = form.querySelector("[data-arpro-purchase-fieldset]");
    var firstReadyVariant = variants.find(function (variant) {
      return variantReadiness(variant, options.serverMode).ready;
    });
    Array.prototype.forEach.call(select.options, function (option) {
      var variant = byId.get(String(option.value));
      var ready = Boolean(variant) && variantReadiness(variant, options.serverMode).ready;
      option.dataset.variantReady = String(ready);
      option.disabled = !variant;
    });
    if (fieldset) {
      var liquidReadable = fieldset.dataset.liquidReadable === "true";
      fieldset.disabled = !(options.transactionReady && variants.length > 0 && liquidReadable);
    }

    var selected = byId.get(String(select.value));
    if (!selected && firstReadyVariant) {
      select.value = String(firstReadyVariant.id);
    }

    function selectedVariant() {
      return byId.get(String(select.value));
    }

    select.addEventListener("change", function () {
      var variant = selectedVariant();
      if (variant) {
        updateVariant(card, variant, options);
        if (typeof options.onVariantChange === "function") options.onVariantChange(card, variant);
      }
    });

    var initial = selectedVariant();
    if (initial) updateVariant(card, initial, options);
    else {
      form.dataset.transactionReady = "false";
      form.querySelectorAll("input, select, button").forEach(function (control) {
        control.disabled = true;
      });
      var unresolvedStatus = form.querySelector("[data-arpro-form-status]");
      if (unresolvedStatus) unresolvedStatus.textContent = "Variante Shopify non résolue. Commande bloquée.";
      return false;
    }
    return true;
  }

  function initializeCatalogue(catalogue) {
    if (!catalogue || catalogue.dataset.arproCatalogueInitialized === "true") return;
    catalogue.dataset.arproCatalogueInitialized = "true";

    var form = catalogue.querySelector("[data-arpro-catalogue-filters]");
    var search = catalogue.querySelector("[data-arpro-catalogue-search]");
    var category = catalogue.querySelector("[data-arpro-catalogue-category]");
    var brand = catalogue.querySelector("[data-arpro-catalogue-brand]");
    var format = catalogue.querySelector("[data-arpro-catalogue-format]");
    var abv = catalogue.querySelector("[data-arpro-catalogue-abv]");
    var purchaseStatus = catalogue.querySelector("[data-arpro-catalogue-purchase-status]");
    var sort = catalogue.querySelector("[data-arpro-catalogue-sort]");
    var grid = catalogue.querySelector("[data-arpro-catalogue-grid]");
    var result = catalogue.querySelector("[data-arpro-catalogue-result]");
    var empty = catalogue.querySelector("[data-arpro-catalogue-empty]");
    var cards = Array.prototype.slice.call(catalogue.querySelectorAll("[data-arpro-catalogue-item]"));
    var expectedCount = Number(catalogue.dataset.expectedCount);
    var expectedVariantCount = Number(catalogue.dataset.expectedVariantCount);
    var serverMode = normalize(catalogue.dataset.arproServerMode);
    var transactionReady = catalogue.dataset.transactionReady === "true";

    if (!grid) return;
    if (!Number.isInteger(expectedCount) || expectedCount < 1) {
      transactionReady = false;
      showRuntimeCountBlock(
        catalogue,
        cards.length,
        expectedCount,
        "Le nombre de produits attendu n’est pas configuré avec une valeur entière positive. Aucun panier ne peut être créé."
      );
      expectedCount = cards.length;
    } else if (cards.length !== expectedCount) {
      transactionReady = false;
      showRuntimeCountBlock(catalogue, cards.length, expectedCount);
    }

    if (!Number.isInteger(expectedVariantCount) || expectedVariantCount < 1) {
      transactionReady = false;
      showRuntimeCountBlock(
        catalogue,
        cards.length,
        expectedCount,
        "Le nombre de variantes attendu n’est pas configuré avec une valeur entière positive. Aucun panier ne peut être créé."
      );
    }

    if (transactionReady) {
      var productIds = cards.map(function (card) { return String(card.dataset.productGid || ""); });
      var productIdsAreUnique = productIds.every(Boolean) && new Set(productIds).size === cards.length;
      var mappingsAreValid = cards.every(hasValidProductMapping);
      var variantGids = cards.flatMap(function (card) {
        return parseVariants(card).map(function (variant) { return String(variant.variantGid || ""); });
      });
      var variantGidsAreComplete = variantGids.length === expectedVariantCount;
      var variantGidsAreUnique = variantGids.every(Boolean) && new Set(variantGids).size === variantGids.length;
      if (!productIdsAreUnique || !mappingsAreValid || !variantGidsAreComplete || !variantGidsAreUnique) {
        transactionReady = false;
        showRuntimeCountBlock(
          catalogue,
          cards.length,
          expectedCount,
          "Le catalogue rendu ne réconcilie pas exactement les " + expectedVariantCount
            + " variantes attendues, ou contient un identifiant absent ou dupliqué. Aucun panier partiel ne peut être créé."
        );
      }
    }

    if (!form || !search || !category || !brand || !format || !abv || !purchaseStatus || !sort || cards.length === 0) return;

    appendOptions(category, cards.map(function (card) { return card.dataset.category; }));
    appendOptions(brand, cards.map(function (card) { return card.dataset.brand; }));
    appendOptions(format, cards.flatMap(function (card) {
      return String(card.dataset.formats || "").split("|||").filter(Boolean);
    }));
    appendOptions(abv, cards.map(function (card) { return card.dataset.abv; }));

    var brandCount = catalogue.querySelector("[data-arpro-catalogue-brand-count]");
    var categoryCount = catalogue.querySelector("[data-arpro-catalogue-category-count]");
    if (brandCount) brandCount.textContent = String(uniqueSorted(cards.map(function (card) { return card.dataset.brand; })).length);
    if (categoryCount) categoryCount.textContent = String(uniqueSorted(cards.map(function (card) { return card.dataset.category; })).length);

    function applyFilters() {
      var query = normalize(search.value);
      var selectedCategory = category.value;
      var selectedBrand = brand.value;
      var selectedFormat = format.value;
      var selectedAbv = abv.value;
      var selectedPurchaseStatus = purchaseStatus.value;
      var visible = 0;

      cards.forEach(function (card) {
        var formats = String(card.dataset.formats || "").split("|||");
        var matchesSearch = !query || card.dataset.searchIndex.indexOf(query) !== -1;
        var matchesCategory = !selectedCategory || card.dataset.category === selectedCategory;
        var matchesBrand = !selectedBrand || card.dataset.brand === selectedBrand;
        var matchesFormat = !selectedFormat || formats.indexOf(selectedFormat) !== -1;
        var matchesAbv = !selectedAbv || card.dataset.abv === selectedAbv;
        var matchesPurchaseStatus = !selectedPurchaseStatus || card.dataset.purchaseStatus === selectedPurchaseStatus;
        var matches = matchesSearch && matchesCategory && matchesBrand && matchesFormat
          && matchesAbv && matchesPurchaseStatus;
        card.hidden = !matches;
        if (matches) card.removeAttribute("aria-hidden");
        else card.setAttribute("aria-hidden", "true");
        if (matches) visible += 1;
      });

      catalogue.dataset.arproVisibleCount = String(visible);
      grid.dataset.arproVisibleCount = String(visible);

      if (result) {
        result.textContent = visible
          + (visible > 1 ? " produits affichés" : " produit affiché")
          + " sur " + expectedCount;
      }
      if (empty) empty.hidden = visible !== 0;

      var url = new URL(window.location.href);
      query ? url.searchParams.set("q", search.value.trim()) : url.searchParams.delete("q");
      selectedCategory ? url.searchParams.set("famille", selectedCategory) : url.searchParams.delete("famille");
      selectedBrand ? url.searchParams.set("marque", selectedBrand) : url.searchParams.delete("marque");
      selectedFormat ? url.searchParams.set("format", selectedFormat) : url.searchParams.delete("format");
      selectedAbv ? url.searchParams.set("degre", selectedAbv) : url.searchParams.delete("degre");
      selectedPurchaseStatus ? url.searchParams.set("achat", selectedPurchaseStatus) : url.searchParams.delete("achat");
      sort.value !== "commercial" ? url.searchParams.set("tri", sort.value) : url.searchParams.delete("tri");
      window.history.replaceState({}, "", url.toString());
    }

    function applySort() {
      cards.slice().sort(function (left, right) {
        if (sort.value === "name-asc") return left.dataset.name.localeCompare(right.dataset.name, "fr");
        if (sort.value === "brand-asc") {
          var brandOrder = left.dataset.brand.localeCompare(right.dataset.brand, "fr");
          return brandOrder || left.dataset.name.localeCompare(right.dataset.name, "fr");
        }
        if (sort.value === "price-asc" || sort.value === "price-desc") {
          var leftPrice = Number(left.dataset.price);
          var rightPrice = Number(right.dataset.price);
          var leftResolved = left.dataset.price !== "" && Number.isFinite(leftPrice);
          var rightResolved = right.dataset.price !== "" && Number.isFinite(rightPrice);
          if (leftResolved !== rightResolved) return leftResolved ? -1 : 1;
          if (!leftResolved) return Number(left.dataset.order) - Number(right.dataset.order);
          return sort.value === "price-asc" ? leftPrice - rightPrice : rightPrice - leftPrice;
        }
        return Number(left.dataset.order) - Number(right.dataset.order);
      }).forEach(function (card) {
        grid.appendChild(card);
      });
    }

    var params = new URL(window.location.href).searchParams;
    search.value = params.get("q") || "";
    restoreCategoryFilter(category, params.get("famille") || "");
    brand.value = params.get("marque") || "";
    format.value = params.get("format") || "";
    abv.value = params.get("degre") || "";
    purchaseStatus.value = params.get("achat") || "";
    var requestedSort = params.get("tri") || "commercial";
    sort.value = Array.prototype.some.call(sort.options, function (option) {
      return option.value === requestedSort;
    }) ? requestedSort : "commercial";

    var options = {
      serverMode: serverMode,
      transactionReady: transactionReady,
      onVariantChange: function () {
        if (sort.value === "price-asc" || sort.value === "price-desc") applySort();
        applyFilters();
      }
    };
    cards.forEach(function (card) {
      card.dataset.searchIndex = normalize(card.dataset.search);
      initializeMediaGallery(card);
      initializeProductForm(card, options);
    });

    search.addEventListener("input", applyFilters);
    [category, brand, format, abv, purchaseStatus].forEach(function (control) {
      control.addEventListener("change", applyFilters);
    });
    sort.addEventListener("change", function () {
      applySort();
      applyFilters();
    });
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      applySort();
      applyFilters();
    });
    form.addEventListener("reset", function () {
      window.setTimeout(function () {
        applySort();
        applyFilters();
      }, 0);
    });

    applySort();
    applyFilters();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches("[data-arpro-catalogue]")) initializeCatalogue(scope);
    scope.querySelectorAll("[data-arpro-catalogue]").forEach(initializeCatalogue);
  }

  window.ARProCatalogue = { initAll: initAll };

  document.addEventListener("click", function (event) {
    var control = event.target.closest("[data-arpro-catalogue-search-open]");
    if (!control) return;
    var catalogue = document.querySelector("[data-arpro-catalogue]");
    var search = catalogue && catalogue.querySelector("[data-arpro-catalogue-search]");
    if (!catalogue || !search) return;
    event.preventDefault();
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    catalogue.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
    window.setTimeout(function () { search.focus(); }, reduceMotion ? 0 : 350);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
  document.addEventListener("arpro:sections-updated", function (event) {
    initAll(event.detail && event.detail.root ? event.detail.root : document);
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  else initAll(document);
})();
